import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

export function writeLog(
  args: Database["public"]["Functions"]["write_log"]["Args"],
) {
  return supabase.rpc("write_log", args);
}
